import Axios from './Base'

const PREFIX = '/_api_'
const ONE_DAY_IN_MS = 1000 * 60 * 60 * 24

export default class WeddingServices {
  constructor(token) {
    this.token = `Bearer ${token.token}`
    this.wedId = token.token_payload.wed_id
    this.axios = Axios({
      cache: true,
      authorization: this.token,
      wedId: this.wedId,
    })
  }

  async getIsWeddingSiteMigrated() {
    return this.axios
      .get(`${PREFIX}/GetIsWeddingSiteMigrated`, {
        id: 'wedding-site-migrated',
        cache: { ttl: ONE_DAY_IN_MS },
      })
      .then((response) => response?.data?.data?.migrated || false)
      .catch(() => false)
  }
}
